import { render, staticRenderFns } from "./DocumentExpireSoonAlerts.vue?vue&type=template&id=2cfbefe7&"
import script from "./DocumentExpireSoonAlerts.vue?vue&type=script&lang=js&"
export * from "./DocumentExpireSoonAlerts.vue?vue&type=script&lang=js&"
import style0 from "./DocumentExpireSoonAlerts.vue?vue&type=style&index=0&id=2cfbefe7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports